import axios from 'utils/axios';

export const getAllTrialRequests = async ({
    perPage = 10,
    pageNo = 1,
    query = '',
    showDisabled = false,
    startDate = '',
    endDate = '',
    sortField = '',
    sorting = '',
    tags = []
}) => {
    try {
        const formattedTags = tags.toString();
        const response = await axios.get('trial-requests/', {
            params: { perPage, pageNo, showDisabled, query, tags: formattedTags, startDate, endDate, sortField, sorting }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const approveTrialRequest = async (id) => {
    try {
        const response = await axios.post('trial-requests/approve', { id });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const denyTrialRequest = async (id, reason) => {
    try {
        const response = await axios.post('trial-requests/deny', { id, reason });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const sendTrialNotification = async (deployment, type) => {
    try {
        const response = await axios.post(`trial-requests/notify/${type}`, { deployment });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const getTrialRequestsSummary = async () => {
    const response = await axios.get('trial-requests/summary');
    return response.data;
};

export const saveTrialRequest = async (data) => {
    try {
        const response = await axios.post('trial-requests/', data);
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
